import { StyledBaseLeaderboard } from '@/components-page/srp/advertisement/styled'
import { GPT_COMPONENT_ID } from '@/features/advertisement/constants/adSlots'

export const BaseLeaderboardAdSlot = () => {
  const baseLeaderboardKey = 'base-leaderboard'

  return (
    <StyledBaseLeaderboard
      id={GPT_COMPONENT_ID.BASE_LEADERBOARD}
      data-testid={GPT_COMPONENT_ID.BASE_LEADERBOARD}
      key={baseLeaderboardKey}
    />
  )
}
